import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { ConfigurationCloseCashViewPage } from '../../../configuration/configuration-close-cash/configuration-close-cash-view/configuration-close-cash-view';

@Component({
  selector: 'page-tutorial-sales',
  templateUrl: 'tutorial-sales.html',
})
export class TutorialSalesPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public dishServices: DishServices) {

  }

  close() {
    /*this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_sales': true,
    }).then(() => {
      this.navCtrl.pop();
    });*/
    this.navCtrl.pop();
  }

  openLink() {
    this.globals.side_menu_active = 'sales';
    this.navCtrl.push(ConfigurationCloseCashViewPage);
    this.navCtrl.remove(this.navCtrl.getActive().index);
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-sales/tutorial-sales.ts